import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

interface GetFileIndividualListRequest {
  fileId: number;
}

export interface IndividualLink {
  hash: string;
  email: string;
  hashForShare: string;
}

const getFileIndividualList = ({ fileId }: GetFileIndividualListRequest) => {
  return api.get<ApiResponse<IndividualLink[]>>('/v2/file/individual', {
    params: {
      fileId,
    },
  });
};

const useFileIndividualList = <
  TData = AxiosResponse<ApiResponse<IndividualLink[]>>,
  TError = AxiosError<ApiErrorResponse>,
>(
  request: GetFileIndividualListRequest,
  options?: UseQueryOptions<
    AxiosResponse<ApiResponse<IndividualLink[]>>,
    TError,
    TData,
    ['getFileIndividualList', GetFileIndividualListRequest]
  >,
): UseQueryResult<TData, TError> => {
  return useQuery(
    ['getFileIndividualList', request],
    () => getFileIndividualList(request),
    {
      ...options,
    },
  );
};

export default useFileIndividualList;
